import { msg } from '@lingui/macro';

export const ONBOARDING_SECTION_TITLES = {
  '': msg`Devenir client`,
  form: msg`Devenir client`,
  status: msg`Statut des demandes d'ouvertures de comptes`,
  'not-found': msg`Page introuvable`,
};
